import { PRODUCTS, labelOf } from "./gulaConstants";
import { fullName, type GulaOrder } from "./gulaTypes";

/** Text to paste into Packlink when creating the shipment. */
export const buildShippingText = (order: GulaOrder) =>
  [
    `Destinatario: ${fullName(order)}`,
    `Teléfono: ${order.phone ?? ""}`,
    `Email: ${order.email ?? ""}`,
    `Dirección: ${order.address ?? ""}`,
    `Código postal: ${order.postal_code ?? ""}`,
    `Población: ${order.city ?? ""}`,
    `Provincia: ${order.province ?? ""}`,
    `Contenido: Equipo de ósmosis ${labelOf(PRODUCTS, order.product)}`,
  ].join("\n");
